import { useNavigate } from "react-router-dom";
import { ROUTES } from "#root/routes/constants";
import { Incident } from "#root/queries/incidents";
import { Button } from "@fluentui/react-components";
import { Edit20Filled, Delete20Filled, QrCode24Filled, DocumentBulletList24Filled, PersonClock20Filled } from "@fluentui/react-icons";
import BaseIncidentsList, { IncidentActionHandlers } from "#root/components/BaseIncidentsList";
import { useVAdminSelectedIncident } from "#root/queries/local";
import "./styles.scss";

const VAdmin: React.FC = () => {
  const navigate = useNavigate();
  const { selectedIncidentId: vAdminIncidentId, setVAdminSelectedIncidentId } = useVAdminSelectedIncident();

  // Render action buttons for VAdmin incidents
  const renderVAdminActions = (incident: Incident, handlers: IncidentActionHandlers) => (
    <>
      {incident.isActive && (
        <>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<QrCode24Filled />}
            onClick={(e) => handlers.onQRCode(incident, e)}
          >
            <span className="button-text">Share QR</span>
          </Button>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<DocumentBulletList24Filled />}
            onClick={(e) => handlers.onCreateReport(incident, e)}
          >
            <span className="button-text">Create AAR</span>
          </Button>
          <Button
            className="expanding-action-button"
            appearance="transparent"
            icon={<PersonClock20Filled />}
            onClick={(e) => navigate(ROUTES.VADMIN.STATUS_REVIEW.replace(':incidentId', incident.id || ''))}
          >
            <span className="button-text">Victim Status Review</span>
          </Button>
        </>
      )}
      <Button
        className="expanding-action-button"
        appearance="transparent"
        icon={<Edit20Filled />}
        onClick={(e) => handlers.onEdit(incident, e)}
      >
        <span className="button-text">Edit</span>
      </Button>
      {!incident.isActive && (
        <Button
          className="expanding-action-button"
          appearance="transparent"
          icon={<Delete20Filled />}
          onClick={(e) => handlers.onDelete(incident, e)}
        >
          <span className="button-text">Delete</span>
        </Button>
      )}
    </>
  );

  const actionCards = [
    {
      image: "general-contacts",
      title: "General Contacts",
      onClick: () => navigate(ROUTES.VADMIN.GENERAL_CONTACTS),
    },
    {
      image: "match-victims",
      title: "Match Victims",
      onClick: () => navigate(ROUTES.VADMIN.MATCH_VICTIMS),
    },
    {
      image: "victim-reunification",
      title: "Victim Reunification",
      onClick: () => navigate(ROUTES.VADMIN.VICTIM_REUNIFICATION),
    },
    {
      image: "family-assistance",
      title: "Family Assistance",
      onClick: () => navigate(ROUTES.VADMIN.FAMILY_ASSISTANCE),
    },
    {
      image: "map-victims",
      title: "Map Victims",
      onClick: () => navigate(ROUTES.VADMIN.MAP_VICTIMS),
    },
    {
      image: "after-action-report",
      title: "After Action Report",
      onClick: () => navigate(ROUTES.VADMIN.AFTER_ACTION_REPORT),
    }
  ];

  const generateQrUrl = (tenantId?: string, incidentId?: string) => {
    return `${window.location.origin}${ROUTES.PUBLIC_REQUEST}?tenantId=${tenantId}&incidentId=${incidentId}`;
  };

  return (
    <BaseIncidentsList
      className="vadmin"
      initialIncidentId={vAdminIncidentId || ''}
      onIncidentChange={setVAdminSelectedIncidentId}
      actionCards={actionCards}
      renderActions={renderVAdminActions}
      generateQrUrl={generateQrUrl}
      extraHeaderActions={undefined}
    />
  );
};

export default VAdmin;
